import BlockTypes from '../../../types/BlockTypes';
export default function canChangeDepth(editor) {
  var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.value.startBlock;
  return [BlockTypes.TODO, BlockTypes.UL_LI, BlockTypes.OL_LI, BlockTypes.UNSTYLED].includes(block.type);
}